export enum StatoNonConformita {
  BOZZA = 'BOZZA',
  DA_CONFERMARE = 'DA_CONFERMARE',
  NUOVA = 'NUOVA',
  DA_PRE_APPROVARE = 'DA_PRE_APPROVARE',
  PRE_APPROVATA = 'PRE_APPROVATA',
  APPROVATA = 'APPROVATA',
  ELIMINATA = 'ELIMINATA',
  RITARDO = 'RITARDO',
}

export enum Tipologia {
  PRODOTTO = 'PRODOTTO',
  PROCESSO = 'PROCESSO',
  CANTIERE = 'CANTIERE'
}
